export default __webpack_public_path__ + "static/FTP-Fritzbox-7490de_09-927d5dcf0b0a4bcbfb89530dc5029a94.webp";